import type { LayoutComponentScreen } from '../types';
import {
  BalancesScreen,
  ChartScreen,
  CreditScreen,
  LadderScreen,
  OrderCardsScreen,
  TradesScreen,
  TransfersScreen,
  WatchListScreen,
} from './screenLibrary';

export const viewOnlyMobileScreens: LayoutComponentScreen[] = [
  WatchListScreen,
  LadderScreen,
  ChartScreen,
  OrderCardsScreen,
  BalancesScreen,
  TradesScreen,
  CreditScreen,
  TransfersScreen,
];
